import { APIClient } from './api_helper';
import * as url from './url_helper';

const api = new APIClient();
// Gets the logged in user data from local session

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = sessionStorage.getItem('user');
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = (data) => {
  return api.create(url.POST_FAKE_REGISTER, data).catch((err) => {
    let message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = 'Sorry! the page you are looking for could not be found';
          break;
        case 500:
          message =
            'Sorry! something went wrong, please contact our support team';
          break;
        case 401:
          message = 'Invalid credentials';
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postLogin = (data) => api.create(url.POST_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = (data) =>
  api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data) =>
  api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) =>
  api.create(url.POST_EDIT_PROFILE, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = 'Sorry! the page you are looking for could not be found';
          break;
        case 500:
          message =
            'Sorry! something went wrong, please contact our support team';
          break;
        case 401:
          message = 'Invalid credentials';
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};
// Login Method
export const postJwtLogin = (data) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data) =>
  api.create(url.POST_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (data) => api.create(url.SOCIAL_LOGIN, data);

//Dashboard
export const getOverview = (data) =>
  api.get(`${url.GET_OVERVIEW}?office=${data}`);
export const getDemographicData = (data) =>
  api.get(`${url.GET_OVERVIEW}/demographic-data?office=${data}`);
export const getOverviewProposalsByPlans = (data) =>
  api.get(`${url.GET_OVERVIEW}/proposals-by-plans?office=${data}`);
export const getOverviewMapsData = (data) =>
  api.get(`${url.GET_OVERVIEW}/customers-by-cities?office=${data}`);
export const getOverviewSalesForecast = (data) =>
  api.get(`${url.GET_OVERVIEW}/sales-forecast?office=${data}`);
export const proposalsSituation = (data) =>
  api.get(
    `${url.GET_PROPOSAL}/by-situation/${data.situation}?office=${data.office}&page=${data.params.page}&length=${data.params.length}&orderBy=${data.params.order_column}&orderPos=${data.params.order_dir}&search=${data.params.search}`
  );

// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);
// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);
// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

//Menu

// get Menu Itens
export const getMenuItens = () => api.get(url.GET_MENU_ITENS);

// types notes
export const getTypesNotes = () => api.get(url.GET_NOTES_TYPE);
export const createTypesNotes = (data) =>
  api.create(url.GET_NOTES_TYPE, { name: data });
export const updateTypesNotes = (data) =>
  api.update(`${url.GET_NOTES_TYPE}/${data.id}`, {
    id: data.id,
    name: data.name,
  });
export const deleteTypesNotes = (id) =>
  api.delete(`${url.GET_NOTES_TYPE}/${id}`);

// categories plans
export const getCategoryPlans = () => api.get(url.GET_CATEGORY_PLANS);
export const createCategoryPlans = (data) =>
  api.create(url.GET_CATEGORY_PLANS, data);
export const updateCategoryPlans = (data) =>
  api.update(`${url.GET_CATEGORY_PLANS}/${data.id}`, {
    id: data.id,
    ...data,
  });
export const deleteCategoryPlans = (id) =>
  api.delete(`${url.GET_CATEGORY_PLANS}/${id}`);

// Associates
export const getAssociates = () => api.get(url.GET_ASSOCIATES);
export const getSummaryAssociates = () => api.get(url.GET_SUMMARY_ASSOCIATES);
export const getOrderAssociates = (data) =>
  api.create(url.GET_ORDER_ASSOCIATES, data);
export const createAssociates = (data) => api.create(url.GET_ASSOCIATES, data);
export const updateAssociates = (data) =>
  api.update(`${url.GET_ASSOCIATES}/${data.id}`, { id: data.id, ...data.data });
export const deleteAssociates = (id) =>
  api.delete(`${url.GET_ASSOCIATES}/${id}`);

// Plans
export const getPlans = (id) =>
  api.get(
    !id || id === 'true' ? url.GET_PLANS : `${url.GET_PLANS}?active=${id}`
  );
export const createPlans = (data) => api.create(url.GET_PLANS, data);
export const updatePlans = (data) =>
  api.update(`${url.GET_PLANS}/${data.id}`, data.data);
export const deletePlans = (id) => api.delete(`${url.GET_PLANS}/${id}`);

// Category Organization
export const getCategoryOrganization = () =>
  api.get(url.GET_CATEGORY_ORGANIZATION);
export const createCategoryOrganization = (data) =>
  api.create(url.GET_CATEGORY_ORGANIZATION, { name: data });
export const updateCategoryOrganization = (data) =>
  api.update(`${url.GET_CATEGORY_ORGANIZATION}/${data.id}`, data);
export const deleteCategoryOrganization = (id) =>
  api.delete(`${url.GET_CATEGORY_ORGANIZATION}/${id}`);

// services
export const getServices = () => api.get(url.GET_SERVICE);
export const createServices = (data) => api.create(url.GET_SERVICE, data);
export const updateServices = (data) =>
  api.update(`${url.GET_SERVICE}/${data.id}`, data.data);
export const deleteServices = (id) => api.delete(`${url.GET_SERVICE}/${id}`);

// seller
export const getSellers = (id) =>
  api.get(
    !id || id === 'true' ? url.GET_SELLERS : `${url.GET_SELLERS}?active=${id}`
  );
export const createSellers = (data) => api.create(url.GET_SELLERS, data);
export const updateSellers = (data) =>
  api.update(`${url.GET_SELLERS}/${data.id}`, data.data);
export const deleteSellers = (id) => api.delete(`${url.GET_SELLERS}/${id}`);

// offices
export const getOffices = () => api.get(url.GET_OFFICES);
export const createOffices = (data) => api.create(url.GET_OFFICES, data);
export const updateOffices = (data) =>
  api.update(`${url.GET_OFFICES}/${data.id}`, { id: data.id, ...data.data });
export const deleteOffices = (id) => api.delete(`${url.GET_OFFICES}/${id}`);

export const getOfficesById = (id) => api.get(`${url.GET_OFFICES}/${id}`);

// Cost center
export const getCostCenter = () => api.get(url.GET_COST_CENTER);
export const createCostCenter = (data) => api.create(url.GET_COST_CENTER, data);
export const updateCostCenter = (data) =>
  api.update(`${url.GET_COST_CENTER}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteCostCenter = (id) =>
  api.delete(`${url.GET_COST_CENTER}/${id}`);

// Category finance
export const getCategoryFinance = () => api.get(url.GET_FINANCE + '-list');
export const getCategoryFinanceOrganized = (data) =>
  api.get(`${url.GET_FINANCE}-organized/${data}`);
export const createCategoryFinance = (data) =>
  api.create(url.GET_FINANCE, data);
export const updateCategoryFinance = (data) =>
  api.update(`${url.GET_FINANCE}/${data.id}`, {
    id: data.id,
    ...data,
  });
export const deleteCategoryFinance = (id) =>
  api.delete(`${url.GET_FINANCE}/${id}`);
export const getCategoriesFinanceSelect = (type) =>
  api.get(url.GET_FINANCE + '-select/' + type);

// Category proposal
export const getProposal = (cpfCnpj) =>
  api.get(url.GET_PROPOSAL + `/${cpfCnpj}`);
export const createProposal = (data) => api.create(url.GET_PROPOSAL, data);
export const updateProposal = (data) =>
  api.update(`${url.GET_PROPOSAL}/${data.id}`, {
    ...data.data,
  });
export const deleteProposal = (id) => api.delete(`${url.GET_PROPOSAL}/${id}`);
export const checkCpfProposal = (data) =>
  api.get(url.GET_ASSOCIATES + `/find-by-cpf/${data}`);
export const getProposalByAssociates = (hashId) =>
  api.get(hashId ? url.GET_PROPOSAL + `?customer=${hashId}` : url.GET_PROPOSAL);

// Proposals files
export const getFiles = (id) => api.get(`${url.GET_PROPOSAL}/upload/${id}`);
export const deleteFiles = (path) =>
  api.create(`${url.GET_PROPOSAL}/upload/delete`, path);
export const downloadFiles = (path) =>
  api.create(`${url.GET_PROPOSAL}/download`, path);
export const cancelProposal = (data) =>
  api.create(`${url.GET_PROPOSAL}/cancel`, data);

export const proposalChangeStatus = (data) =>
  api.create(`${url.GET_PROPOSAL}/change-status`, {
    proposal_id: data.proposal_id,
    status_id: data.status,
    reason: data.reason,
  });
export const proposalReactive = (data) =>
  api.create(`${url.GET_PROPOSAL}/change-status`, {
    proposal_id: data.proposal_id,
    status_id: data.status_id,
    reason: data.reason,
  });

// Select kinship
export const getKinship = () => api.get(url.GET_KINSHIP);

// Organizations
export const getOrganizations = (id) =>
  api.get(
    !id || id === 'true'
      ? url.GET_ORGANIZATIONS
      : `${url.GET_ORGANIZATIONS}?active=${id}`
  );
export const createOrganizations = (data) =>
  api.create(url.GET_ORGANIZATIONS, data);
export const updateOrganizations = ({ id, data }) => {
  api.update(`${url.GET_ORGANIZATIONS}/${id}`, data);
};
export const deleteOrganizations = (id) =>
  api.delete(`${url.GET_ORGANIZATIONS}/${id}`);

// Notes Associates
export const getNotesAssociates = (id) =>
  api.create(url.GET_NOTESASSOCIATES + '-list', {
    customer_id: id,
  });
export const createNotesAssociates = (data) =>
  api.create(url.GET_NOTESASSOCIATES, data);
export const updateNotesAssociates = (data) =>
  api.update(`${url.GET_NOTESASSOCIATES}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteNotesAssociates = (id) =>
  api.delete(`${url.GET_NOTESASSOCIATES}/${id}`);

// Units
export const getUnits = () => api.get(url.GET_UNITS);
export const createUnits = (data) => api.create(url.GET_UNITS, data);
export const updateUnits = (data) =>
  api.update(`${url.GET_UNITS}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteUnits = (id) => api.delete(`${url.GET_UNITS}/${id}`);
export const createDepartment = (data) => api.create(url.GET_UNITS, data);

// Specialties
export const getSpecialties = () => api.get(url.GET_SPECIALTIES);
export const createSpecialties = (data) =>
  api.create(url.GET_SPECIALTIES, data);
export const updateSpecialties = (data) =>
  api.update(`${url.GET_SPECIALTIES}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteSpecialties = (id) =>
  api.delete(`${url.GET_SPECIALTIES}/${id}`);

// Provider Specialties
export const getProviderSpecialty = (id) =>
  api.get(url.GET_PROVIDER_SPECIALTIES + `?provider=${id}`);
export const getProviderSpecialtyById = (id) =>
  api.get(`${url.GET_PROVIDER_SPECIALTIES}/${id}`);
export const createProviderSpecialty = (data) =>
  api.create(url.GET_PROVIDER_SPECIALTIES, data);
export const updateProviderSpecialty = (data) =>
  api.update(`${url.GET_PROVIDER_SPECIALTIES}/${data.id}`, {
    ...data.data,
  });
export const deleteProviderSpecialty = (id) =>
  api.delete(`${url.GET_PROVIDER_SPECIALTIES}/${id}`);

// Users
export const getUsers = () => api.get(url.GET_USERS);
export const createUsers = (data) => api.create(url.GET_USERS, data);
export const updateUsers = (data) =>
  api.update(`${url.GET_USERS}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteUsers = (id) => api.delete(`${url.GET_USERS}/${id}`);

// Credentials Network (NT)
export const getCredentialsNT = (data) =>
  api.get(
    !data.status || data.status === 'true'
      ? `${url.GET_CREDENTIALSNT}?state=${data.params.state}&city=${data.params.city}&neighborhood=${data.params.neigh}&specialty=${data.params.specialty}`
      : `${url.GET_CREDENTIALSNT}?active=${data.status}&state=${data.params.state}&city=${data.params.city}&neighborhood=${data.params.neigh}&specialty=${data.params.specialty}`
  );
export const createCredentialsNT = ({ data }) =>
  api.create(url.GET_CREDENTIALSNT, data);
export const updateCredentialsNT = (data) =>
  api.update(`${url.GET_CREDENTIALSNT}/${data.id}`, {
    id: data.id,
    ...data.data,
  });
export const deleteCredentialsNT = (id) =>
  api.delete(`${url.GET_CREDENTIALSNT}/${id}`);
export const getCredentialsNTStates = () =>
  api.get(`${url.GET_CREDENTIALSNT}/states`);
export const getCredentialsNTSpecialties = (data) =>
  api.get(
    `${url.GET_CREDENTIALSNT}/specialties?estado=${data.state}&cidade=${data.city}&bairro=${data.neigh}`
  );

// Visit Schedule
export const getSchedule = (id) =>
  api.get(url.GET_SCHEDULE + `?provider=${id}`);
export const getScheduleById = (id) => api.get(`${url.GET_SCHEDULE}/${id}`);
export const createSchedule = (data) => api.create(url.GET_SCHEDULE, data);
export const updateSchedule = (data) =>
  api.update(`${url.GET_SCHEDULE}/${data.id}`, {
    ...data.data,
  });
export const updateScheduleRealized = (data) =>
  api.update(`${url.GET_SCHEDULE}/${data.id}`, {
    ...data.data,
  });
export const deleteSchedule = (id) => api.delete(`${url.GET_SCHEDULE}/${id}`);

// Reports
export const getReports = () => api.get(url.GET_REPORTS);
export const proposalBySeller = (data) =>
  api.create(`${url.GET_REPORTS}/proposal/by-seller`, data);
export const searchAssociates = (data) =>
  api.get(`${url.GET_ASSOCIATES}/incremental-search?q=${data}`);

// Accounts
export const accountsGet = () => api.get(url.GET_ACCOUNTS);

export const accountsGetById = (id) =>
  api.get(`${url.GET_ACCOUNT_BY_ID}/${id}`);

export const accountsCreate = (data) => api.create(url.CREATE_ACCOUNTS, data);

export const accountsEdit = (data) =>
  api.update(`${url.UPDATE_ACCOUNTS}/${data.id}`, data.data);

export const accountsDelete = (id) =>
  api.delete(`${url.DELETE_ACCOUNTS}/${id}`);

// History status
export const getHistoryStatus = (id) =>
  api.get(url.GET_HISTORY_STATUS + `?proposal_id=${id}`);
export const createHistoryStatus = (data) =>
  api.create(url.GET_HISTORY_STATUS, data);
export const deleteHistoryStatus = (id) =>
  api.delete(`${url.GET_HISTORY_STATUS}/${id}`);

// SupplierList
export const getSuppliesList = (id) =>
  api.get(
    !id || id === 'true'
      ? url.GET_SUPPLIESLIST
      : `${url.GET_SUPPLIESLIST}?active=${id}`
  );
export const getSuppliersLookup = () =>
  api.get(`${url.GET_SUPPLIESLIST}/lookup`);
export const updateSuppliesList = ({ id, data }) => {
  api.update(`${url.GET_SUPPLIESLIST}/${id}`, {
    ...data,
  });
};
export const createSuppliesList = ({ data }) =>
  api.create(url.GET_SUPPLIESLIST, { ...data });
export const deleteSuppliesList = (id) =>
  api.delete(`${url.GET_SUPPLIESLIST}/${id}`);

// Bills To Pay
export const getBillsToPay = (data) =>
  api.get(
    data.period.length
      ? `${url.GET_BILLS_TO_PAY}?start=${data.period[0]}&end=${
          data.period[1] + `&status=${data.status}&type=${data.type}`
        }`
      : `${url.GET_BILLS_TO_PAY + `?status=${data.status}&type=${data.type}`}`
  );
export const getBillsToPayByHash = (hash) =>
  api.get(`${url.GET_BILLS_TO_PAY}/${hash}`);
export const createBillsToPay = (data) =>
  api.create(url.GET_BILLS_TO_PAY, data);
export const updateBillsToPay = (data) =>
  api.update(`${url.GET_BILLS_TO_PAY}/${data.hash}`, {
    ...data.data,
  });
export const deleteBillsToPay = (hash) =>
  api.delete(`${url.GET_BILLS_TO_PAY}/${hash}`);

// Validation Of Proposals
export const getPreProposal = () => api.get(`${url.GET_PRE_PROPOSAL}`);
export const getPreProposalByHash = (hash) =>
  api.get(`${url.GET_PRE_PROPOSAL}/${hash}`);
export const updatePreProposal = (data) =>
  api.update(`${url.GET_PRE_PROPOSAL}/${data.hash}`, {
    ...data.data,
  });
export const pendingPreProposal = (data) =>
  api.create(`${url.GET_PRE_PROPOSAL}/pending/${data.hash}`, {
    ...data.data,
  });
export const approvePreProposal = (hash) =>
  api.create(`${url.GET_PRE_PROPOSAL}/approve/${hash}`);
